module.exports = __webpack_public_path__ + "static/media/ini5-90w.c60a94e4.jpg";